import { IonButton, IonCard, IonIcon, IonCardContent, IonImg, IonCardHeader, IonCardTitle, IonCol, IonContent, IonGrid, IonItem, IonLabel, IonList, IonPage, IonRow, IonSelect, IonSelectOption } from '@ionic/react';
import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer';
import { translation } from '../../models/translation';
import { fetchOrgPages, fetchOrgPagesFiterable } from '../../services/org_service';
import { fetchCats } from '../../services/taxononmies';
import { safeSubstring } from '../../utlities/safeSubstring';
import { refreshOutline } from 'ionicons/icons';
import { fetchOptions } from '../../services/options_service';
import { OptionPages } from '../../models/apiModels';
import Meta from '../../components/Meta';

interface Taxonomy {
    name: string,
    id: number,
    parent: number,
    acf: any
}

const Organizations: React.FC = () => {

    const categoryIds = {
        theme: process.env.NODE_ENV === "production" ? 42 : 26,
        location: process.env.NODE_ENV === "production" ? 43 : 33,
        label: process.env.NODE_ENV === "production" ? 41 : 37,
    }

    const siteText = translation();
    const lan = siteText.lan.replace("/", "")

    const [siteOptions, setSiteOptions] = useState<OptionPages>();


    const [organizations, setOrganizations] = useState([])
    const [orgData, setOrgData] = useState([])

    const [themes, setThemes] = useState([])
    const [areasOfAction, setAreasOfAction] = useState([])
    const [labels, setLabels] = useState([])

    const [catThemesSelect, setThemesSelect] = useState([])
    const [catActionAreaSelect, setActionAreaSelect] = useState([])
    const [catLabelSelection, setLabelSelect] = useState([])


    useEffect(() => {
        getOrganisations();
        getCategories();
        getOptions();
    }, [])

    useEffect(() => {
        let filterSelection = [...catThemesSelect, ...catActionAreaSelect, ...catLabelSelection]
        getFilteredData(filterSelection)
    }, [catLabelSelection, catActionAreaSelect, catThemesSelect])

    const getOrganisations = async () => {
        let data = await fetchOrgPages([''])
        setOrganizations(data.message)
        setOrgData(data.message)
        return
    }

    const getFilteredData = async (catSelection: any) => {
        await fetchOrgPagesFiterable(catSelection).then(m =>
            setOrganizations(m.message)
        )
    }

    const getCategories = async () => {
        let data = await fetchCats().then(m => m)
        if (data.message && data.message.filter((m: any) => m.parent !== 0)) {
            setThemes(data.message.filter((m: Taxonomy) => m.parent === categoryIds.theme))
            setAreasOfAction(data.message.filter((m: Taxonomy) => m.parent === categoryIds.location))
            setLabels(data.message.filter((m: Taxonomy) => m.parent === categoryIds.label))
        }

    }

    const getOptions = async () => {
        let resp: any = await fetchOptions();
        if (!resp.error) {
            let options: OptionPages = resp.message;
            setSiteOptions(options);
        }
    }

    const clearFilter = () => {
        setActionAreaSelect([])
        setThemesSelect([])
        setLabelSelect([])
        setOrganizations(orgData)
        return
    }


    const descriptionHtml = (html: any) => {
        html = `${safeSubstring(html, 210)} ...`
        return { __html: html }
    }

    return (
        <IonPage>
            {siteText.lan === '/en' && <Meta url={window.location.href} description={`${siteOptions?.acf.orgpage_heading_description.en.seo_description}`} title={`${siteOptions?.acf.orgpage_heading_description.en.seo_title}`} ></Meta>}
            {siteText.lan === '/fr' && <Meta url={window.location.href} description={`${siteOptions?.acf.orgpage_heading_description.fr.seo_description}`} title={`${siteOptions?.acf.orgpage_heading_description.fr.seo_title}`} ></Meta>}
            {siteText.lan === '/de' && <Meta url={window.location.href} description={`${siteOptions?.acf.orgpage_heading_description.de.seo_description}`} title={`${siteOptions?.acf.orgpage_heading_description.de.seo_title}`} ></Meta>}
            <IonContent>
                <IonGrid>
                    <IonRow className='sw_sp_md'>
                        <IonCol offsetSm='1' sizeSm='10'>
                            {lan === "en" && <>
                                <h1>+{siteOptions?.acf.orgpage_heading_description.en?.heading ?? siteText.charitiesTitle}</h1>
                                <p dangerouslySetInnerHTML={{ __html: siteOptions?.acf.orgpage_heading_description.en?.description ?? '' }}></p>
                            </>}
                            {lan === "fr" && <>
                                <h1>+{siteOptions?.acf.orgpage_heading_description.fr?.heading ?? siteText.charitiesTitle}</h1>
                                <p dangerouslySetInnerHTML={{ __html: siteOptions?.acf.orgpage_heading_description.fr?.description ?? '' }}></p>
                            </>}
                            {lan === "de" && <>
                                <h1>+{siteOptions?.acf.orgpage_heading_description.de?.heading ?? siteText.charitiesTitle}</h1>
                                <p dangerouslySetInnerHTML={{ __html: siteOptions?.acf.orgpage_heading_description.de?.description ?? '' }}></p>
                            </>}
                        </IonCol>
                    </IonRow>
                    <IonRow className='lightTertiaryBackground'>
                        <IonCol>
                            <IonRow style={{ marginTop: '-45px' }}>
                                <IonCol>
                                    <IonList className='organizations_filter_bar' lines='none' style={{ background: 'transparent' }}>
                                        <IonItem lines='none' color='light'>
                                            <IonLabel>{siteText.charityPageThemeSelectLabel}</IonLabel>
                                            {themes.length > 0 ?
                                                <IonSelect multiple className='unbordered' interface='popover' value={catThemesSelect} onIonChange={(event: any) => setThemesSelect(event.detail.value)}>
                                                    {themes.map((theme: Taxonomy, key: any) => { return <IonSelectOption style={{ whiteSpace: 'normal' }} key={key} value={theme.id}>{theme.acf[lan]}</IonSelectOption> }
                                                    )}
                                                </IonSelect> :
                                                <IonSelect className="unbordered" interface='popover' disabled></IonSelect>

                                            }

                                        </IonItem>
                                        <IonItem lines='none' color='light' >
                                            <IonLabel>{siteText.charityPageLocationSelectLabel}</IonLabel>
                                            {areasOfAction.length > 0 ?
                                                <IonSelect multiple className='unbordered' interface='popover' value={catActionAreaSelect} onIonChange={(event: any) => setActionAreaSelect(event.detail.value)}>
                                                    {areasOfAction.map((theme: Taxonomy, key: any) => { return <IonSelectOption key={key} value={theme.id}>{theme.acf[lan]}</IonSelectOption> }
                                                    )}
                                                </IonSelect> :
                                                <IonSelect className="unbordered" interface='popover' disabled></IonSelect>

                                            }

                                        </IonItem>
                                        <IonItem lines='none' color='light'>
                                            <IonLabel>{siteText.charityPageLabelSelectLabel}</IonLabel>
                                            {labels.length > 0 ?
                                                <IonSelect multiple className='unbordered' interface='popover' value={catLabelSelection} onIonChange={(event: any) => setLabelSelect(event.detail.value)}>
                                                    {labels.map((theme: Taxonomy, key: any) => { return <IonSelectOption key={key} value={theme.id}>{theme.acf[lan]}</IonSelectOption> }
                                                    )}
                                                </IonSelect> :
                                                <IonSelect className="unbordered" interface='popover' disabled></IonSelect>

                                            }
                                        </IonItem>
                                        <IonButton className='roundButton' mode='ios' color='light' onClick={() => clearFilter()}>
                                            <IonIcon slot='icon-only' color='medium' icon={refreshOutline}></IonIcon>
                                        </IonButton>
                                    </IonList>
                                </IonCol>
                            </IonRow>
                            <IonRow className='charities_list sw_sp_md'>
                                {

                                    organizations.length > 0 ?

                                        organizations.map((org: any, key: any) => {
                                            if (org.acf[lan] && org.acf[lan].nom) {
                                                return (<IonCol sizeXs="12" sizeSm='4' sizeMd="3" key={key}>
                                                    <IonCard>
                                                        <IonCardHeader>
                                                            <img style={{ maxHeight: "60px" }} src={org.acf[lan] ? `${org.acf[lan].logo}` : ''}></img>
                                                            <IonCardTitle dangerouslySetInnerHTML={{ __html: org.acf[lan].nom }}></IonCardTitle>
                                                        </IonCardHeader>
                                                        <IonCardContent>
                                                            {/*<p className='ion-text-right'><a href={`${org.acf[lan].site_url}`}>web site</a></p>*/}
                                                            <div dangerouslySetInnerHTML={descriptionHtml(org.acf[lan].description)}></div>
                                                            <IonButton routerLink={`/${lan}/charities/${org.id}`} className='ion-margin-bottom' size='small' fill='outline' style={{ float: 'right' }}>{siteText.detailsBtnTxt}</IonButton>
                                                        </IonCardContent>
                                                    </IonCard>
                                                </IonCol>
                                                )
                                            } else { return '' }
                                        }

                                        )


                                        :
                                        <></>
                                }
                            </IonRow>
                        </IonCol>
                    </IonRow>

                </IonGrid>
                <Footer></Footer>
            </IonContent>
        </IonPage>
    );

};

export default Organizations;
